module.exports = __webpack_public_path__ + "static/pablo-81a0396cc5930f406f84fea93d2c983f.webp";